/**
 * Copyright 2025 (c) Karsten Röthig, FVA GmbH (for umati and VDW e.V.)
 */
import React, { ReactElement } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { TemplateContext } from 'templates/pubSub/types/TemplateContextType';
import SectionAccordionCard from './SectionAccordionCard';
import SectionAccordionCardPlaceholder from './SectionAccordionCardPlaceholder';
import TemplateHelperPubSub from 'utilities/TemplateHelperPubSub';
import RenderOnCondition from './RenderOnCondition';

interface ISectionAccordionCardsProps {
  templateContext: TemplateContext;
}

export default function SectionAccordionCards(props: ISectionAccordionCardsProps): ReactElement {
  const template = props.templateContext.template;
  return (
    <>
      {template.sections.map((section, sectionIndex) => (
        <RenderOnCondition
          key={TemplateHelperPubSub.getPlaceholderKey(section.id, sectionIndex)}
          templateContext={props.templateContext}
          condition={section.condition}
        >
          <Accordion defaultActiveKey={section.id}>
            {!section.placeholders || section.placeholders.length === 0 ? (
              <SectionAccordionCard
                eventKey={section.id}
                templateContext={props.templateContext}
                section={section}
                isExpanded={sectionIndex === 0}
              />
            ) : (
              <SectionAccordionCardPlaceholder
                templateContext={props.templateContext}
                section={section}
                placeholder={section.placeholders[0]}
                placeholderIndex={0}
              />
            )}
          </Accordion>
        </RenderOnCondition>
      ))}
    </>
  );
}
